import { render, staticRenderFns } from "./IndustryComboSaleTrigger.vue?vue&type=template&id=f2485bb2"
import script from "./IndustryComboSaleTrigger.vue?vue&type=script&lang=js"
export * from "./IndustryComboSaleTrigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports